import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-363">
      <div className="max-w-5xl mx-auto" data-id="element-364">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-365">
          Lo que <span className="text-[#FFD700]" data-id="element-366">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-367">
          <div className="bg-black border border-[#FFD700]/30 rounded-2xl p-6" data-id="element-368">
            <h3 className="text-[#FFD700] text-xl font-black mb-4" data-id="element-369">
              🎭 LOS 6 TOMOS
            </h3>
            <div className="space-y-3" data-id="element-370">
              <div className="flex items-start gap-3 text-white" data-id="element-371">
                <span className="text-lg" data-id="element-372">🟢</span>
                <p className="text-sm" data-id="element-373">
                  <span className="font-bold" data-id="element-374">Tomo 1 — Nivel Inicial</span>{' '}
                  <span className="text-gray-400" data-id="element-375">
                    · Sala de 3, 4 y 5 años · Planificaciones listas · Rituales
                    · Rúbricas por sala
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-376">
                <span className="text-lg" data-id="element-377">🟡</span>
                <p className="text-sm" data-id="element-378">
                  <span className="font-bold" data-id="element-379">
                    Tomo 2 — Primaria Primer Ciclo
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-380">
                    · 1ro a 3ro grado · 6 unidades por grado · Impro · Personaje
                    · Función anual guiada
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-381">
                <span className="text-lg" data-id="element-382">🟠</span>
                <p className="text-sm" data-id="element-383">
                  <span className="font-bold" data-id="element-384">
                    Tomo 3 — Primaria Segundo Ciclo
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-385">
                    · 4to a 7mo · Teatro Foro · Stanislavski accesible ·
                    Dramaturgia propia
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-386">
                <span className="text-lg" data-id="element-387">🔴</span>
                <p className="text-sm" data-id="element-388">
                  <span className="font-bold" data-id="element-389">Tomo 4 — Secundaria Básica</span>{' '}
                  <span className="text-gray-400" data-id="element-390">
                    · 1ro a 3ro año · Técnica actoral · Identidad · Brecht ·
                    Manejo de grupos difíciles
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-391">
                <span className="text-lg" data-id="element-392">🟣</span>
                <p className="text-sm" data-id="element-393">
                  <span className="font-bold" data-id="element-394">
                    Tomo 5 — Secundaria Orientada
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-395">
                    · 4to a 6to · Meisner + Viewpoints · Dirección escénica ·
                    Obra de egreso
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-396">
                <span className="text-lg" data-id="element-397">⭐</span>
                <p className="text-sm" data-id="element-398">
                  <span className="font-bold" data-id="element-399">Tomo 6 — Talleres y Adultos</span>{' '}
                  <span className="text-gray-400" data-id="element-400">
                    · Todos los niveles · CENS · Adultos mayores · Teatro
                    comunitario
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-[#FFD700]/5 border border-[#FFD700]/30 rounded-2xl p-8 text-center" data-id="element-401">
          <h3 className="text-[#FFD700] text-xl font-black mb-6" data-id="element-402">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-403">
            <div className="flex items-start gap-2 text-left" data-id="element-404">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-405">✅</span>
              <span className="text-white text-sm" data-id="element-406">
                Planificación anual lista para presentar a dirección
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-407">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-408">✅</span>
              <span className="text-white text-sm" data-id="element-409">
                Consignas exactas (qué decir, palabra por palabra)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-410">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-411">✅</span>
              <span className="text-white text-sm" data-id="element-412">
                Rúbricas · Seguimiento individual · Informes para familias
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-413">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-414">✅</span>
              <span className="text-white text-sm" data-id="element-415">
                100% adaptado a la realidad educativa argentina
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}